module.exports = __webpack_public_path__ + "static/media/UCLA Sample Planning Station.436284e1.pdf";